module.exports = __webpack_public_path__ + "static/1136640820.0854884b.jpg";